import { SET_FLOW_GROUP_ATTRIBUTE_TAB } from '../../actions'
import { Logger, LoggerTypes } from '../../utils'

export const flowGroupElements = (state = {}, action) => {
  switch (action.type) {
    // -- SET FLOW GROUP ATTRIBUTE TAB
    case SET_FLOW_GROUP_ATTRIBUTE_TAB: {
      const elementId = action?.data?.elementId || null
      const type = action?.data?.element?.type || null
      const id = action?.data?.element?.id || null

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] flowGroupElements.SET_FLOW_GROUP_ATTRIBUTE_TAB()', {
        state,
        action,
        elementId,
        type,
        id
      })

      return {
        ...state,
        elementId,
        type,
        id
      }
    }

    default:
      return state
  }
}
